// extracted by mini-css-extract-plugin
module.exports = {"header":"a10a3f92e9--header--AkTGE","heart":"a10a3f92e9--heart--PSDxx","body":"a10a3f92e9--body--HBy2Z","close":"a10a3f92e9--close--zDnoL"};